import React, { useEffect, useState } from 'react';
import { Alert, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const MaintenanceBanner: React.FC = () => {
  // Check if maintenance mode is enabled via environment variable
  const isMaintenanceMode = process.env.REACT_APP_MAINTENANCE_MODE === 'true';
  
  // State to track if banner is dismissed by user (only for current session)
  const [isDismissed, setIsDismissed] = useState(false);
  
  // Get custom maintenance message or use default
  const maintenanceMessage = process.env.REACT_APP_MAINTENANCE_MESSAGE || 
    'Estamos mejorando el sitio para una mayor comodidad de nuestros usuarios. Retomaremos el funcionamiento normal el lunes a las 7:00 am. Muchas gracias.';

  // Check if banner should be shown
  const shouldShowBanner = isMaintenanceMode && !isDismissed;

  // Handle banner dismissal (only for current session)
  const handleDismiss = () => {
    setIsDismissed(true);
  };

  // Add padding to body when maintenance banner is active and visible
  useEffect(() => {
    if (shouldShowBanner) {
      document.body.style.paddingTop = '70px'; // Adjust based on banner height
    } else {
      document.body.style.paddingTop = '0';
    }

    // Cleanup function to reset padding when component unmounts
    return () => {
      document.body.style.paddingTop = '0';
    };
  }, [shouldShowBanner]);

  if (!shouldShowBanner) {
    return null;
  }

  return (
    <Alert 
      severity="warning" 
      sx={{ 
        textAlign: 'center', 
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: (theme) => theme.zIndex.drawer + 300, // Higher than GlobalNotification
        borderRadius: 0, // Full width banner
        minHeight: '60px',
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
        pr: 6, // Add right padding to account for close button
      }}
      action={
        <IconButton
          aria-label="cerrar"
          color="inherit"
          size="small"
          onClick={handleDismiss}
          sx={{
            position: 'absolute',
            right: 8,
            top: '50%',
            transform: 'translateY(-50%)',
          }}
        >
          <CloseIcon fontSize="inherit" />
        </IconButton>
      }
    >
      {maintenanceMessage}
    </Alert>
  );
};

export default MaintenanceBanner;
